import { Component, Input } from '@angular/core';
import { SafeScriptComponent } from '../../script-injector/safe-script/safe-script.component';

@Component({
  selector: 'lib-option-label',
  standalone: true,
  imports: [SafeScriptComponent],
  templateUrl: './option-label.component.html',
  styleUrl: './option-label.component.css',
})
export class OptionLabelComponent {
  @Input({ required: true }) label!: string;
  @Input() isExclusive: boolean = false;
}